module.exports = __webpack_public_path__ + "static/img/60-3.6ff2c2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/60-3.jpg
// module id = WwYv
// module chunks = 0